import { FormattedMessage } from 'react-intl';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { COLORS } from 'theme/MainTheme';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  notSelectedButton: {
    borderColor: COLORS.BLUE,
    color: COLORS.BLUE,

    '&:hover': {
      borderColor: COLORS.BLUE,
    },
  },
  rightButton: {
    marginLeft: 20,
  },
}), { name: 'UnselectedButton' });

export type UnselectedButtonProps = {
  value: boolean;
  disabled: boolean;
  labelId: string;
  onClick: () => void;
};

const UnselectedButton = ({ value, disabled, labelId, onClick } : UnselectedButtonProps) : JSX.Element => {
  const classes = useStyles();

  const className = clsx([
    classes.notSelectedButton,
    !value && classes.rightButton,
  ]);
  return (
    <Button
      className={className}
      disabled={disabled}
      variant="outlined"
      onClick={onClick}
    >
      <FormattedMessage id={labelId} />
    </Button>
  );
}

export default UnselectedButton;